<template>
  <div class="page">
    <!-- Setup header -->
    <DashboardHeader
      @showVoegTekenaarToeModal="$emit('showVoegTekenaarToeModal')"
      @showVoegOpdrachtToeModal="$emit('showVoegOpdrachtToeModal')"
    />
    <div class="page-wrapper">
      <!-- Dashboard top items -->
      <div class="overview sticky">
        <div></div>
        <div class="item">
          <span class="itemfocus">{{
            aantalOpdrachtenPerWeek.toFixed(1)
          }}</span>
          <span>Opdrachten per week (2021)</span>
        </div>
        <div class="divider"></div>
        <div class="item">
          <span style="color:#f1646c" class="itemfocus">{{
            aantalGeaccepteerdeOpdrachten
          }}</span>
          <span>Geaccepteerde opdrachten</span>
        </div>
        <div class="divider"></div>
        <div class="item">
          <span style="color:#35dd83" class="itemfocus">{{
            allActieveOpdrachten.length
          }}</span>
          <span>Actieve opdrachten</span>
        </div>
        <div class="divider"></div>
        <div class="item">
          <span style="color:#ff9326" class="itemfocus">{{
            aantalBeëindigdeOpdrachten
          }}</span>
          <span>Afgeronde opdrachten</span>
        </div>
        <!-- <div class="divider"></div> -->
        <!-- <div class="item" style="background-color: #ecf3fc;">
          <span class="itemfocus">{{ allTekenaars.length }}</span>
          <span>Aangesloten tekenaars</span>
        </div> -->
        <div></div>
      </div>

      <div class="splitview">
        <div class="list">
          <h3 style="font-weight:600;">Opdrachten per discipline</h3>
          <ul class="discul">
            <li
              class="discipline"
              v-for="discipline in disciplines"
              :key="discipline.index"
              :class="{
                pastel1: discipline == 'Bouwkunde',
                pastel2: discipline == 'Werktuigbouwkunde',
                pastel3: discipline == 'Installatietechniek',
                pastel4: discipline == 'Elektrotechniek',
                pastel5: discipline == 'Huisvesting',
                pastel6: discipline == 'Plattegronden',
                pastel7: discipline == 'Concepten - 3D Print',
                pastel8: discipline == 'Brandpreventie',
                displaynone: discipline == 'Nen2580',
                pastel9: discipline == 'Sem'
              }"
            >
              {{ discipline }}: {{ opdrachtenPerDiscipline(discipline) }}
            </li>
          </ul>
        </div>
        <div class="divider"></div>

        <div class="list">
          <h3 style="font-weight:600;">Opdrachten per status</h3>
          <ul>
            <li v-for="status in statussen" :key="status.index">
              {{ status }}: {{ opdrachtenPerStatus(status) }}
            </li>
            <li>
              On Hold:
              {{
                allOpdrachten.filter(
                  opdracht => opdracht.onhold && !opdracht.geannuleerd
                ).length
              }}
            </li>
            <li>
              Geannuleerd:
              {{
                allOpdrachten.filter(opdracht => opdracht.geannuleerd).length
              }}
            </li>
            <li style="font-weight:600;">
              Totaal:
              {{ allOpdrachten.length }}
            </li>
          </ul>
        </div>
      </div>

      <!-- Uitgezette opdrachten -->
      <div class="splitview" style="padding-top:60px;">
        <div class="list" style="width:100%;background-color:none;">
          <h3 style="font-weight:600;">Te accepteren opdrachten</h3>
          <div
            class="uitgezetHolder"
            v-if="filteredUitgezetteOpdrachten.length > 0"
          >
            <!-- <div v-for="opdracht in filteredUitgezetteOpdrachten" :key="opdracht.id" @click="$emit('select-opdracht', opdracht.id)">
              <div class="uitgezetteOpdracht">
                <span>CDT.2020.{{ opdracht.opdrachtnummer }}</span>
                <span>{{ opdracht.bedrijfsnaam }}</span>
                <span
                  class="discipline"
                  :class="{
                    pastel1: opdracht.disciplines == 'Bouwkunde',
                    pastel2: opdracht.disciplines == 'Werktuigbouwkunde',
                    pastel3: opdracht.disciplines == 'Installatietechniek',
                    pastel4: opdracht.disciplines == 'Elektrotechniek',
                    pastel5: opdracht.disciplines == 'Huisvesting',
                    pastel6: opdracht.disciplines == 'Plattegronden',
                    pastel7: opdracht.disciplines == 'Concepten - 3D Print',
                    pastel8: opdracht.disciplines == 'Brandpreventie',
                    pastel9: opdracht.disciplines == 'Nen2580'
                  }"
                  >{{ opdracht.disciplines }}</span
                >
                <span tekenaar>Test Tekenaar</span>
              </div>
            </div> -->
            <!-- <OpdrItemsHeaderNieuw /> -->

            <OpdrItemsHeaderUitgezet />

            <div
              v-for="opdracht in filteredUitgezetteOpdrachten"
              :key="opdracht.id"
              @click="$emit('select-opdracht', opdracht.id)"
            >
              <!-- <OpdrachtItemNieuw :opdracht="opdracht" /> -->
              <OpdrachtItemUitgezet :opdracht="opdracht" />
            </div>
          </div>
          <div v-if="filteredUitgezetteOpdrachten.length == 0">
            Er zijn geen niet geaccepteerde opdrachten
          </div>
        </div>
      </div>

      <!-- Nieuwe opdrachten (todo) -->
      <div class="splitview" style="padding-top:60px;">
        <div class="list" style="width:100%;">
          <h3 style="font-weight:600;">Todo</h3>
          <div v-if="filteredNieuweOpdrachten.length > 0">
            <OpdrItemsHeaderNieuw />
            <div
              v-for="opdracht in orderBy(
                filteredNieuweOpdrachten,
                'opdrachtnummer',
                -1
              )"
              :key="opdracht.id"
              @click="$emit('select-opdracht', opdracht.id)"
            >
              <OpdrachtItemNieuw :opdracht="opdracht" />
            </div>
          </div>
          <div v-if="filteredNieuweOpdrachten.length == 0">
            Super! Er zijn geen todos meer
          </div>
        </div>
      </div>

      <div class="splitview" style="padding-top:60px;"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import store from '@/store'
import Vue2Filters from 'vue2-filters'

import DashboardHeader from './DashboardHeader'
import OpdrItemsHeaderNieuw from '../Opdrachten/OpdrItemsHeaderNieuw'
import OpdrItemsHeaderUitgezet from '../Opdrachten/OpdrItemsHeaderUitgezet'

import OpdrachtItemNieuw from '../Opdrachten/OpdrachtItemNieuw'
import OpdrachtItemUitgezet from '../Opdrachten/OpdrachtItemUitgezet'

export default {
  name: 'Dashboard',
  mixins: [Vue2Filters.mixin],
  components: {
    DashboardHeader,
    OpdrachtItemNieuw,
    OpdrachtItemUitgezet,
    OpdrItemsHeaderNieuw,
    OpdrItemsHeaderUitgezet
  },
  data () {
    return {}
  },

  computed: {
    ...mapGetters(['allOpdrachten']),

    statussen () {
      return store.state.statussen
    },
    disciplines () {
      return store.state.disciplines
    },
    allOpdrachten () {
      return store.getters.allOpdrachten
    },
    allActieveOpdrachten () {
      return store.getters.allOpdrachten
        .filter(opdracht => opdracht.status === 'Gestart')
        .filter(opdracht => !opdracht.onhold)
        .filter(opdracht => opdracht.status != 'Beëindigd')
        .filter(opdracht => !opdracht.geannuleerd)
    },
    allOpdrachten2021 () {
      return this.allOpdrachten.filter(
        opdracht => opdracht.opdrachtnummerjaar == '2021'
      )
    },
    aantalGeaccepteerdeOpdrachten () {
      return this.allOpdrachten
        .filter(opdracht => opdracht.status == 'Geaccepteerd')
        .filter(opdracht => !opdracht.onhold)
        .filter(opdracht => !opdracht.geannuleerd).length
    },
    aantalBeëindigdeOpdrachten () {
      return this.allOpdrachten.filter(
        opdracht => opdracht.status == 'Beëindigd'
      ).length
    },
    allTekenaars () {
      return store.getters.allTekenaars
    },
    aantalOpdrachtenPerWeek () {
      const weeknumber = new Date().getWeek()
      return this.allOpdrachten2021.length / weeknumber
    },

    filteredNieuweOpdrachten () {
      return this.allOpdrachten
        .filter(
          opdracht =>
            (opdracht.status == 'Nieuw' && opdracht.onhold != true) ||
            (opdracht.status == 'In behandeling' && opdracht.onhold != true)
        )
        .filter(opdracht => opdracht.geannuleerd != true)
        .filter(opdracht => {
          const opdrachtnummer = 'CDT.2020.' + opdracht.opdrachtnummer
          return opdrachtnummer
            .toString()
            .toLowerCase()
            .includes(store.state.opdrFilters.opdrachtnummer)
        })
        .filter(opdracht => {
          return opdracht.bedrijfsnaam
            .toLowerCase()
            .includes(store.state.opdrFilters.bedrijfsnaam.toLowerCase())
        })
        .filter(opdracht => {
          return opdracht.status
            .toLowerCase()
            .includes(store.state.opdrFilters.status.toLowerCase())
        })
        .filter(opdracht => {
          if (store.state.opdrFilters.disciplines == '') {
            return opdracht
          } else {
            return opdracht.disciplines.includes(
              store.state.opdrFilters.disciplines
            )
          }
        })
    },
    filteredUitgezetteOpdrachten () {
      return this.allOpdrachten
        .filter(
          opdracht => opdracht.status == 'Uitgezet' && opdracht.onhold != true
        )
        .filter(opdracht => opdracht.geannuleerd != true)
        .filter(opdracht => {
          const opdrachtnummer = 'CDT.2020.' + opdracht.opdrachtnummer
          return opdrachtnummer
            .toString()
            .toLowerCase()
            .includes(store.state.opdrFilters.opdrachtnummer)
        })
        .filter(opdracht => {
          return opdracht.bedrijfsnaam
            .toLowerCase()
            .includes(store.state.opdrFilters.bedrijfsnaam.toLowerCase())
        })
        .filter(opdracht => {
          return opdracht.status
            .toLowerCase()
            .includes(store.state.opdrFilters.status.toLowerCase())
        })
        .filter(opdracht => {
          if (store.state.opdrFilters.disciplines == '') {
            return opdracht
          } else {
            return opdracht.disciplines.includes(
              store.state.opdrFilters.disciplines
            )
          }
        })
    }
  },
  methods: {
    opdrachtenPerDiscipline (discipline) {
      const opdrachten = this.allOpdrachten
        .filter(opdracht => !opdracht.geannuleerd)
        .filter(opdracht => opdracht.disciplines == discipline)
      return opdrachten.length
    },
    opdrachtenPerDisciplinePerJaar (discipline, jaar) {
      const opdrachten = this.allOpdrachten
        .filter(opdracht => !opdracht.geannuleerd)
        .filter(opdracht => opdracht.disciplines == discipline)
        .filter(opdracht => opdracht.opdrachtnummerjaar == jaar)
      return opdrachten.length
    },
    opdrachtenPerStatus (status) {
      if (status == 'Nieuw') {
        const opdrachten = this.allOpdrachten
          .filter(opdracht => !opdracht.geannuleerd)
          .filter(opdracht => !opdracht.onhold)
          .filter(
            opdracht =>
              (opdracht.status == status) |
              (opdracht.status == 'In behandeling')
          )

        return opdrachten.length
      } else {
        const opdrachten = this.allOpdrachten
          .filter(opdracht => !opdracht.geannuleerd)
          .filter(opdracht => !opdracht.onhold)
          .filter(opdracht => opdracht.status == status)
        return opdrachten.length
      }
    },
    tekenaarsPerDiscipline (discipline) {
      const opdrachten = this.allOpdrachten
        .filter(opdracht => !opdracht.geannuleerd)
        .filter(opdracht => opdracht.disciplines == discipline)
      return opdrachten.length
    }
  }
}

Date.prototype.getWeek = function () {
  var onejan = new Date(this.getFullYear(), 0, 1)
  return Math.ceil(((this - onejan) / 86400000 + onejan.getDay() + 1) / 7)
}

// var weekNumber = new Date().getWeek();

// var dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
// var now = new Date();
// document.write(dayNames[now.getDay()] + ' (' + weekNumber + ').');
</script>

<style scoped>
/* Bovenste balk */
.overview {
  background-color: white;
  border-radius: 6px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 36px 0;
  align-items: stretch;
}
.sticky {
  position: sticky !important;
  top: 100px;
}
.overview .divider {
  width: 2px;
  height: auto;
  background-color: black;
  opacity: 0.1;
}
.overview .item {
  display: flex;
  flex-direction: column;
}
.overview .item span {
  font-size: 15px;
  font-weight: 400;
  opacity: 0.5;
}
.overview .item .itemfocus {
  font-size: 30px;
  font-weight: 600;
  opacity: 1;
}

/* splitview */
.splitview {
  padding-top: 40px;
  display: flex;
  flex-direction: row;
}
.splitview .divider {
  min-width: 40px;
}

/* Disciplines list */
.list {
  background-color: white;
  border-radius: 6px;
  padding: 30px;
  width: auto;
  min-width: 33%;
}

.list h3 {
  padding-bottom: 20px;
}

.discul {
  display: flex;
  flex-wrap: wrap;
}

.displaynone {
  display: none !important;
}

.discipline {
  background-color: #e4ecfa;
  border-radius: 100px;
  padding: 5px 10px;
  margin-bottom: 15px;
  display: flex;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  margin-right: 7px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  min-width: 30%;
}

/* Uitgezette opdrachten */

.uitgezetHolder {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.uitgezetteOpdracht {
  padding: 12px 20px;
  background-color: #ecf3fc;
  border-radius: 6px;
  margin-bottom: 15px;
  /* width: 100%; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}
.uitgezetteOpdracht:hover {
  opacity: 0.6;
}
.uitgezetteOpdracht .discipline {
  margin-bottom: 0;
}
</style>
